import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LocationService } from '../service/location.service';
import { LocationSearchRequest } from '../model/location-search-request.model';
import { Location } from '../model/location';
import { FormsModule } from '@angular/forms';
import { AsyncPipe, NgIf } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { CoreUtilsModule } from '../../core-utils';

@Component({
    selector: 'jhi-storage-locations-select',
    standalone: true,
    imports: [
        FormsModule,
        NgIf,
        AsyncPipe,
        NgSelectModule,
        CoreUtilsModule
    ],
    templateUrl: './storage-locations-select.component.html'
})
export class StorageLocationsSelectComponent implements OnInit {

    @Input() value: number;
    @Output() valueChange = new EventEmitter<number>();

    storageLocations: Promise<Location[]>;
    favoriteLocations: Promise<Location[]>;

    favoriteLocation = false;
    storageLocationType = [1500];

    storageLocIdSelected;
    favoriteLocIdSelected;

    constructor(private locationService: LocationService) {
        const locationSearchRequest: LocationSearchRequest = new LocationSearchRequest();
        locationSearchRequest.locationTypeIds = this.storageLocationType;
        this.storageLocations = this.locationService.searchLocations(locationSearchRequest, false, null).toPromise();
        this.favoriteLocations = this.locationService.searchLocations(locationSearchRequest, true, null).toPromise();

        const defaultLocation = this.locationService.getDefaultStorageLocation().toPromise();
        defaultLocation.then((location) => {
            this.storageLocIdSelected = location.id;
            this.value = location.id;
            this.onValueChanged(this.value);
        });
    }

    ngOnInit(): void {
    }

    onValueChanged($event): void {
        this.value = this.favoriteLocation ? Number(this.favoriteLocIdSelected) : Number(this.storageLocIdSelected);
        this.valueChange.emit(this.value);
    }
}
